(function () {

  var cmPreview = null;
  var cmLightbox = null;

  function showToast(msg) {
    var existing = document.querySelector('.cm-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cm-toast';
    toast.textContent = msg;
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.2s ease';
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.style.opacity = '1'; });
    });
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 200);
    }, 2500);
  }

  function updateCartCount(count) {
    document.querySelectorAll('cart-count.header__cart-count, .bubble-count').forEach(function (el) {
      el.textContent = count;
    });
  }

function refreshCart() {
  setTimeout(function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // 同时刷新 mini-cart section 内容
        return fetch('/?sections=mini-cart');
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['mini-cart']) {
          var temp = document.createElement('div');
          temp.innerHTML = sections['mini-cart'];
          var newContent = temp.querySelector('cart-drawer');
          var oldContent = document.querySelector('cart-drawer');
          if (newContent && oldContent) {
            oldContent.innerHTML = newContent.innerHTML;
          }
        }
      })
      .catch(function () {});
  }, 800);
}


  function doAtc(variantId, btn, addedText) {
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

xhr.onload = function () {
  if (xhr.status === 200) {
    btn.style.background = '#444';
    btn.style.color = '#888';
    btn.innerHTML = '<span style="color:#ff6b00;font-size:1.2em;">\u2713</span>';
    showToast('\u2713 ' + addedText);
    refreshCart();
    setTimeout(function () {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
      btn.style.background = '';
      btn.style.color = '';
    }, 3000);
  } else {
    btn.innerHTML = originalHtml;
    btn.disabled = false;
  }
};


    xhr.onerror = function () {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    };

    xhr.send(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }));
  }

  function getPreview() {
    if (!cmPreview) {
      cmPreview = document.createElement('div');
      cmPreview.className = 'cm-img-preview';
      cmPreview.innerHTML = '<img src="" alt="">';
      document.body.appendChild(cmPreview);
    }
    return cmPreview;
  }

  function getLightbox() {
    if (!cmLightbox) {
      cmLightbox = document.createElement('div');
      cmLightbox.className = 'cm-lightbox';
      cmLightbox.innerHTML =
        '<div class="cm-lightbox-inner">' +
          '<img src="" alt="">' +
          '<button class="cm-lightbox-close">\u00d7</button>' +
        '</div>';
      document.body.appendChild(cmLightbox);
      cmLightbox.querySelector('.cm-lightbox-close').addEventListener('click', function () {
        cmLightbox.classList.remove('cm-lightbox-open');
      });
      cmLightbox.addEventListener('click', function (e) {
        if (e.target === cmLightbox) cmLightbox.classList.remove('cm-lightbox-open');
      });
    }
    return cmLightbox;
  }

  function bindImgInteraction(imgWrap, largeSrc) {
    if (window.innerWidth > 768) {
      var preview = getPreview();
      var previewImg = preview.querySelector('img');
      imgWrap.addEventListener('mouseenter', function () {
        previewImg.src = largeSrc;
        preview.classList.add('cm-img-preview--visible');
      });
      imgWrap.addEventListener('mousemove', function (e) {
        preview.style.left = (e.clientX + 20) + 'px';
        preview.style.top = Math.max(10, e.clientY - 150) + 'px';
      });
      imgWrap.addEventListener('mouseleave', function () {
        preview.classList.remove('cm-img-preview--visible');
      });
    } else {
      imgWrap.addEventListener('click', function () {
        var lb = getLightbox();
        lb.querySelector('img').src = largeSrc;
        lb.classList.add('cm-lightbox-open');
      });
    }
  }

  function renderList(products, atcText, oosText, addedText) {
    var list = document.getElementById('cm-list');
    if (!list) return;
    list.innerHTML = '';

    products.forEach(function (item) {
      var available = item.available;
      var variants = item.variants || [];
      var firstAvailable = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { firstAvailable = variants[i]; break; }
      }
      var multiVariant = variants.length > 1;

      var div = document.createElement('div');
      div.className = 'cm-item' + (available ? '' : ' cm-item--oos');

      var imgHtml = '';
      if (item.image) {
        imgHtml =
          '<div class="cm-img-wrap">' +
            '<img src="' + item.image + '" class="cm-img" alt="' +
            item.title.replace(/"/g, '&quot;') + '" width="72" height="72">' +
          '</div>';
      }

      var selectHtml = '';
      if (multiVariant) {
        selectHtml = '<select class="cm-variant-select">';
        variants.forEach(function (v) {
          var dis = v.available ? '' : ' disabled';
          var suffix = v.available ? '' : ' \u2014 ' + oosText;
          selectHtml += '<option value="' + v.id + '"' + dis + '>' + v.title + suffix + '</option>';
        });
        selectHtml += '</select>';
      }

      var btnHtml = available
        ? '<button class="cm-atc-btn">' + atcText + '</button>'
        : '<button class="cm-atc-btn cm-oos" disabled>' + oosText + '</button>';

      // ── 竖排卡片结构，对齐 Bag 页 ──
      div.innerHTML =
        '<div class="cm-item__header">' +
          imgHtml +
          '<div class="cm-info">' +
            '<a href="' + item.url + '" class="cm-product-title">' + item.title + '</a>' +
            '<p class="cm-price">' + item.price_min_formatted + '</p>' +
          '</div>' +
        '</div>' +
        selectHtml +
        btnHtml;

      var imgWrap = div.querySelector('.cm-img-wrap');
      if (imgWrap && item.image_large) {
        bindImgInteraction(imgWrap, item.image_large);
      }

      var btn = div.querySelector('.cm-atc-btn');
      var select = div.querySelector('.cm-variant-select');

      if (btn && available) {
        if (select && firstAvailable) {
          select.value = firstAvailable.id;
        }

        btn.addEventListener('click', function () {
          var variantId = select
            ? Number(select.value)
            : (variants[0] ? variants[0].id : null);
          if (!variantId) return;
          doAtc(variantId, btn, addedText);
        });

        if (select) {
          select.addEventListener('change', function () {
            var chosen = null;
            for (var i = 0; i < variants.length; i++) {
              if (String(variants[i].id) === select.value) { chosen = variants[i]; break; }
            }
            if (chosen && chosen.available) {
              btn.disabled = false;
              btn.classList.remove('cm-oos');
              btn.innerHTML = atcText;
            } else {
              btn.disabled = true;
              btn.classList.add('cm-oos');
              btn.innerHTML = oosText;
            }
          });
        }
      }

      list.appendChild(div);
    });
  }

  function init() {
    var block = document.getElementById('compatible-mounts-block');
    if (!block) return;

    var dataEl = document.getElementById('cm-products-data');
    if (!dataEl) return;

    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) {
      console.warn('[cm] parse error', e); return;
    }

    var atcText   = block.dataset.atc   || 'Add to Cart';
    var oosText   = block.dataset.oos   || 'Out of Stock';
    var addedText = block.dataset.added || 'Added to cart';

    renderList(products, atcText, oosText, addedText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
